import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const DEFAULT_CURRENCY = "BRL";

export const CURRENCY_OPTIONS = [
  { value: "BRL", label: "BRL / Real", symbol: "R$" },
];

export function CurrencySelect({ value = DEFAULT_CURRENCY, onValueChange, disabled = false }) {
  return (
    <Select value={value || DEFAULT_CURRENCY} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {CURRENCY_OPTIONS.map((currency) => (
          <SelectItem key={currency.value} value={currency.value}>
            {currency.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
